import React, { useState } from "react";
import { trackLead, errMessage } from "@/lib/api";
import { Loader2, ArrowRight, Check } from "lucide-react";

export default function TrackStatus() {
  const [id, setId] = useState("");
  const [mobile, setMobile] = useState("");
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  async function submit(e) {
    e.preventDefault();
    setErr(""); setBusy(true);
    try { setData(await trackLead(id.trim(), mobile.trim())); }
    catch (e2) { setErr(errMessage(e2, "Could not fetch status.")); setData(null); }
    finally { setBusy(false); }
  }

  return (
    <main data-testid="track-page" className="pt-24 md:pt-32 pb-24">
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="chapter-index text-emerald-700">Application · Tracker</p>
        <h1 className="font-display text-5xl md:text-7xl leading-[0.95] mt-3">Track your <span className="italic text-emerald-800">application.</span></h1>

        <form onSubmit={submit} data-testid="track-form" className="mt-10 rounded-3xl bg-white border border-black/[0.06] p-8 md:p-10 grid gap-4">
          <input data-testid="track-id" required value={id} onChange={(e)=>setId(e.target.value)} placeholder="Application ID (e.g. RWF-2512-XXXXXX)" className="rounded-2xl border border-slate-200 px-4 py-3 text-sm outline-none focus:border-emerald-500 font-mono"/>
          <input data-testid="track-mobile" required value={mobile} onChange={(e)=>setMobile(e.target.value)} placeholder="Mobile number used at application" inputMode="numeric" className="rounded-2xl border border-slate-200 px-4 py-3 text-sm outline-none focus:border-emerald-500"/>
          <button data-testid="track-submit" disabled={busy} className="btn-line rounded-full bg-slate-900 text-white py-3 text-sm inline-flex items-center justify-center gap-2">
            {busy ? <Loader2 className="animate-spin" size={16}/> : <>Track <ArrowRight size={16}/></>}
          </button>
          {err && <p data-testid="track-error" className="text-sm text-red-600">{err}</p>}
        </form>

        {data && (
          <div data-testid="track-result" className="mt-10 rounded-3xl bg-white border border-black/[0.06] p-8 md:p-10">
            <div className="flex items-center justify-between flex-wrap gap-3">
              <div>
                <p className="chapter-index text-emerald-700">{data.application_id}</p>
                <p className="font-display text-3xl text-slate-900 mt-1">{data.name}</p>
                <p className="text-sm text-slate-500">{data.loan_product}</p>
              </div>
              <p className="rounded-full bg-emerald-100 text-emerald-800 px-4 py-2 text-sm">{data.status}</p>
            </div>
            <ol className="mt-10 relative border-l border-slate-200 pl-6 space-y-6">
              {data.timeline.map((t, i) => (
                <li key={i}>
                  <span className={`absolute -left-[9px] w-4 h-4 rounded-full grid place-items-center ${t.reached ? 'bg-emerald-600 text-white' : 'bg-white border border-slate-300 text-slate-400'}`}>{t.reached && <Check size={10}/>}</span>
                  <p className={`font-display text-xl ${t.current ? 'text-emerald-800' : t.reached ? 'text-slate-900' : 'text-slate-400'}`}>{t.label}</p>
                </li>
              ))}
            </ol>
            <p className="mt-8 text-xs text-slate-500">{data.note}</p>
          </div>
        )}
      </section>
    </main>
  );
}
